import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import Products from './pages/Products';
import Furrmap from './pages/Furrmap';
import About from './pages/About';
import Contact from './pages/Contact';
import Cart from './pages/Cart';
import UserProfile from './pages/UserProfile';
import Animals from './pages/Animals';
import ProductDetails from './pages/ProductDetails';

import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/products" element={<Products />} />
            <Route path="/productDetails" element={<ProductDetails />} />
            <Route path="/animals" element={<Animals />} />
            <Route path="/furrmap" element={<Furrmap />} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/cart" element={<Cart />} />
            <Route path="/account" element={<UserProfile />} />
          </Routes>
        </main>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;